export default "__VITE_ASSET__CvTYTE5O__"